// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Algeria from '../_raw/flag/icon_flag_algeria.png';

export default () => <img src={Algeria} alt="Algeria" />;
